
import {
  addAccretionService,
  upAccretionService,
  delAccretionService
} from "@/api/oms-operation-service";
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import regular from "@/common/regular";
import uploadImage from "@/components/upload-image/upload-image.vue";
import showImg from "@/components/show-img/show-img.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-upload-image": uploadImage,
    "pi-show-img": showImg
  }
})
export default class PiAddValueServiceBox extends Vue {
  private modalShow = false;
  private loading = false;
  private modalTitle = i18n.t("addValueService.add");
  private FormData: objAny = {};

  private radioList: object[] = [
    { itemValue: i18n.t("addValueService.enable"), itemKey: "0" },
    { itemValue: i18n.t("addValueService.disabled"), itemKey: "1" }
  ];

  private ruleInline: objAny = {
    serviceName: [
      {
        required: true,
        validator: regular.name,
        name: i18n.t("addValueService.serviceName"),
        trigger: "blur",
        max: 20
      }
    ],
    logo: [
      {
        required: true,
        message: i18n.t("addValueService.logoPl"),
        trigger: "blur"
      }
    ],
    hasOpen: [
      {
        required: true,
        message: i18n.t("addValueService.hasOpenPl"),
        trigger: "change"
      }
    ]
  };
  private itemData: objAny = {};
  private formItem: objAny = {
    hasOpen: "",
    logo: "",
    serviceName: "",
    accretionServicePkId: "",
    logoUrl: ""
  };

  public open(item?: objAny) {
    this.modalShow = true;
    this.itemData = item || {};
    if (item) {
      this.formItem.hasOpen = item.hasOpen + "";
      this.formItem.logo = item.logo;
      this.formItem.serviceName = item.serviceName;
      this.formItem.accretionServicePkId = item.accretionServicePkId;
      this.formItem.logoUrl = item.logoUrl || "";
    } else {
      this.formItem.hasOpen = "";
      this.formItem.logo = "";
      this.formItem.serviceName = "";
      this.formItem.accretionServicePkId = "";
      this.formItem.logoUrl = "";
    }
  }

  public closeModal(): void {
    this.modalShow = false;
  }
  public handleReset() {
    this.FormData.resetFields();
  }
  public handleSubmit() {
    const formItem: objAny = this.$refs.formItem;
    formItem.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  async submitData(): Promise<void> {
    let ret;
    this.loading = true;
    const json: objAny = {
      logo: this.formItem.logo,
      serviceName: this.formItem.serviceName,
      hasOpen: this.formItem.hasOpen
    };
    if (this.itemData.accretionServicePkId) {
      json.accretionServicePkId = this.itemData.accretionServicePkId;
      ret = await upAccretionService(json);
    } else {
      ret = await addAccretionService(json);
    }
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
  }

  public uploadImg(data: objAny): void {
    this.formItem.logoUrl = data.thumbnailFilePath;
    this.formItem.logo = data.attachmentRecordPkId;
    console.log(this.formItem);
  }

  async delItem() {
    const ret = await delAccretionService({
      accretionServicePkId: this.itemData.accretionServicePkId
    });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("deleteSuccess"));
      this.$emit("success");
      this.modalShow = false;
    }
  }
}
